export function cli(): string {
  return 'cli';
}
